import React from 'react';
import { useSelector } from 'react-redux';
import last from 'lodash/last';
import omit from 'lodash/omit';

import { getOrganizationDomain } from 'Shared/selectors/organization';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

import CreateTeammateByEmailField from '../CreateTeammateByEmailField/CreateTeammateByEmailField';
import { WpIcon } from 'Wpds/components/icon';

type Props = {
  formValues: Array<{
    fullName: string;
    teammateEmail: string;
    recurringMeetingId: number | null;
    errorMessage: string | null;
    userId?: number | null;
    fromCalendar?: boolean;
  }>;
  isSuggestedListOpened: boolean;
  onSetFormValues: Function;
  onSetIsSuggestedListOpened: Function;
};

const emptyFormValueTemplate = domain => ({
  fullName: '',
  teammateEmail: domain,
  recurringMeetingId: null,
  errorMessage: null,
  fromCalendar: false,
});

function AddByEmailNameSection({
  formValues,
  isSuggestedListOpened,
  onSetFormValues,
  onSetIsSuggestedListOpened,
}: Props) {
  const { tr } = useTranslation();
  const organizationDomain = useSelector(getOrganizationDomain);

  const handleEmailInputChange = (event, key) => {
    onSetIsSuggestedListOpened(true);
    onSetFormValues({ ...formValues, [key]: { ...formValues[key], teammateEmail: event.target.value } });
  };

  const handleNameInputChange = (event, key) => {
    onSetIsSuggestedListOpened(true);
    onSetFormValues({ ...formValues, [key]: { ...formValues[key], fullName: event.target.value } });
  };

  const handleNewItemAddClick = () => {
    const lastKey = last(Object.keys(formValues));
    const newKey = parseInt(lastKey, 10) + 1;
    onSetFormValues({ ...formValues, [newKey]: emptyFormValueTemplate(organizationDomain) });
  };

  const handleRemoveItem = key => onSetFormValues(omit(formValues, [key]));

  const handleRemoveRecurringMeetingId = key => {
    onSetFormValues({ ...formValues, [key]: { ...formValues[key], recurringMeetingId: null } });
  };

  const handleSuggestionClick = ({ identif, fullName, email, recurringMeetingId }) => {
    onSetFormValues({
      ...formValues,
      [identif]: {
        ...formValues[identif],
        fullName,
        teammateEmail: email,
        recurringMeetingId,
      },
    });
  };

  return (
    <div className="add-by-email-name-section">
      <div className="mt-3">
        {Object.entries(formValues).map((formValue, index) => {
          return (
            <CreateTeammateByEmailField
              formValues={formValues}
              key={formValue[0]}
              index={index}
              isSuggestedListOpened={isSuggestedListOpened}
              valuesCount={formValues.length}
              identif={formValue[0]}
              formValue={formValue[1]}
              onEmailInputChange={handleEmailInputChange}
              onNameInputChange={handleNameInputChange}
              onRemoveItem={handleRemoveItem}
              onRemoveRecurringMeetingId={handleRemoveRecurringMeetingId}
              onSuggestionClick={handleSuggestionClick}
              onSetIsSuggestedListOpened={onSetIsSuggestedListOpened}
            />
          );
        })}
      </div>
      <button
        type="button"
        onClick={handleNewItemAddClick}
        className="bulk-invite-temmates-modal-button btn btn-link text-decoration-none p-0 mb-3"
      >
        <span className="mr-1">
          <WpIcon name="plus-circle" />
        </span>
        {tr('perform.workspace.simple_bulk_invite.add_another')}
      </button>
    </div>
  );
}

export default AddByEmailNameSection;
